import MailboxConnectButtons from "../../components/MailboxConnectButtons";

const LoginSocialAuth = ({ helpText }: { helpText?: string }) => {
  return <MailboxConnectButtons variant="login" helpText={helpText} />;
};

export default LoginSocialAuth;
